import React from 'react'

const SignInIcon = () => {
    return (
        <svg
            style={{ height: '100%' }}
            // width="25" height="24" 
            viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.802 2H14.202C11.002 2 9.00195 4 9.00195 7.2V11.25H13.442L11.372 9.18C11.222 9.03 11.152 8.84 11.152 8.65C11.152 8.46 11.222 8.27 11.372 8.12C11.662 7.83 12.142 7.83 12.432 8.12L15.782 11.47C16.072 11.76 16.072 12.24 15.782 12.53L12.432 15.88C12.142 16.17 11.662 16.17 11.372 15.88C11.082 15.59 11.082 15.11 11.372 14.82L13.442 12.75H9.00195V16.8C9.00195 20 11.002 22 14.202 22H16.792C19.992 22 21.992 20 21.992 16.8V7.2C22.002 4 20.002 2 16.802 2Z" fill="#FFFFFF" />
            <path d="M2.75195 11.25C2.34195 11.25 2.00195 11.59 2.00195 12C2.00195 12.41 2.34195 12.75 2.75195 12.75H9.00195V11.25H2.75195Z" fill="#FFFFFF" />
        </svg>


    )
}

export default SignInIcon